import React from "react"

import FieldTags from "../../tags"

const debug = false
// const debug = "FieldTags_EditableValue"

type Props = {
    field   : FieldTags
    model   : any
}

export default function FieldTags_EditableValue(props: Props) {
    const field = props.field as any as FieldTags
    const value = field.getViewValue(props.model)

    if (_.isEmpty(value)) return null // value = array (!)

    const valueOptions   = field._getOptions(value)

    if (!valueOptions) return null

    let optionsToShow   = valueOptions.length
    let moreOptions     = 0

    debug && console.log(debug, "optionsToShow", optionsToShow, "moreOptions=", moreOptions)

    return (
        <div className="multiselect-container">
            {_.map(valueOptions, (option, key) => {
                if (key >= optionsToShow) return

                return <field.components.Pill key       = {option.value}
                                              className = "m-r-10"
                                              style     = {{maxWidth: field.pillMaxWidth}}
                                              option    = {option} />

            })}

            {(moreOptions > 0) && <div className="ui5-link-small">{"+{0}".f(moreOptions)}</div>}
        </div>
    )
}

